export const MS_UNTIL_READ = 5000;
